// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/lookups/lookup.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";

export const protobufPackage = "services.lookups";

export interface GetLookItemsRequest {
  categoryName: string;
}

export interface LookupItem {
  categoryName: string;
  items: StringList[];
}

export interface StringList {
  values: string[];
}

function createBaseGetLookItemsRequest(): GetLookItemsRequest {
  return { categoryName: "" };
}

export const GetLookItemsRequest: MessageFns<GetLookItemsRequest> = {
  encode(message: GetLookItemsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.categoryName !== "") {
      writer.uint32(10).string(message.categoryName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetLookItemsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetLookItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.categoryName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetLookItemsRequest {
    return {
      categoryName: isSet(object.categoryName)
        ? globalThis.String(object.categoryName)
        : isSet(object.category_name)
        ? globalThis.String(object.category_name)
        : "",
    };
  },

  toJSON(message: GetLookItemsRequest): unknown {
    const obj: any = {};
    if (message.categoryName !== "") {
      obj.categoryName = message.categoryName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetLookItemsRequest>, I>>(base?: I): GetLookItemsRequest {
    return GetLookItemsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetLookItemsRequest>, I>>(object: I): GetLookItemsRequest {
    const message = createBaseGetLookItemsRequest();
    message.categoryName = object.categoryName ?? "";
    return message;
  },
};

function createBaseLookupItem(): LookupItem {
  return { categoryName: "", items: [] };
}

export const LookupItem: MessageFns<LookupItem> = {
  encode(message: LookupItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.categoryName !== "") {
      writer.uint32(10).string(message.categoryName);
    }
    for (const v of message.items) {
      StringList.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LookupItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLookupItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.categoryName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.items.push(StringList.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LookupItem {
    return {
      categoryName: isSet(object.categoryName)
        ? globalThis.String(object.categoryName)
        : isSet(object.category_name)
        ? globalThis.String(object.category_name)
        : "",
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => StringList.fromJSON(e)) : [],
    };
  },

  toJSON(message: LookupItem): unknown {
    const obj: any = {};
    if (message.categoryName !== "") {
      obj.categoryName = message.categoryName;
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => StringList.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LookupItem>, I>>(base?: I): LookupItem {
    return LookupItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LookupItem>, I>>(object: I): LookupItem {
    const message = createBaseLookupItem();
    message.categoryName = object.categoryName ?? "";
    message.items = object.items?.map((e) => StringList.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStringList(): StringList {
  return { values: [] };
}

export const StringList: MessageFns<StringList> = {
  encode(message: StringList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.values) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StringList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStringList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.values.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StringList {
    return {
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: StringList): unknown {
    const obj: any = {};
    if (message.values?.length) {
      obj.values = message.values;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StringList>, I>>(base?: I): StringList {
    return StringList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StringList>, I>>(object: I): StringList {
    const message = createBaseStringList();
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

export interface LookupService {
  getLookupItems(request: DeepPartial<GetLookItemsRequest>, metadata?: grpc.Metadata): Promise<LookupItem>;
}

export class LookupServiceClientImpl implements LookupService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.getLookupItems = this.getLookupItems.bind(this);
  }

  getLookupItems(request: DeepPartial<GetLookItemsRequest>, metadata?: grpc.Metadata): Promise<LookupItem> {
    return this.rpc.unary(LookupServiceGetLookupItemsDesc, GetLookItemsRequest.fromPartial(request), metadata);
  }
}

export const LookupServiceDesc = { serviceName: "services.lookups.LookupService" };

export const LookupServiceGetLookupItemsDesc: UnaryMethodDefinitionish = {
  methodName: "GetLookupItems",
  service: LookupServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetLookItemsRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = LookupItem.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
